/**
 * @fileoverview UpdateProfile component
 *
 * Will implement the Update Profile functionality
 */

import SelectorEngine from '../../utils/dom/selector-engine';
import Request from '../../utils/request';
import attachValidation from '../../utils/form-validation';
import { getDataFromForm } from '../../utils/misc';

class UpdateProfile {
	constructor(element) {
		this._element = element;

		if (this._element) {
			this.initiateValidation();
		}
	}

	showError(errorType) {
		const errorPopup = SelectorEngine.findOne('.lta-update-profile--error', this._element);
		const errorPopupCta = SelectorEngine.findOne('.js-dismiss-error', errorPopup);
		const list = SelectorEngine.find('li', errorPopup);
		if (errorType === 'api') {
			list[0].classList.add('u-hidden');
			list[1].classList.remove('u-hidden');
		} else {
			list[0].classList.remove('u-hidden');
			list[1].classList.add('u-hidden');
		}
		errorPopup.classList.remove('u-hidden');
		errorPopupCta.focus();
	}

	addManualFormValidation(form) {
		this.manualFormValidationInstance = attachValidation(form, {
			firstName: {
				validators: {
					notEmpty: {
						message: 'Please enter your first name'
					},
					regexp: {
						regexp: /^[a-zA-Z-' ]+$/,
						message: 'Please enter a valid first name'
					}
				}
			},
			lastName: {
				validators: {
					notEmpty: {
						message: 'Please enter your surname'
					},
					regexp: {
						regexp: /^[a-zA-Z-' ]+$/,
						message: 'Please enter a valid surname'
					}
				}
			},
			dateOfBirth: {
				validators: {
					notEmpty: {
						message: 'Please enter a valid date of birth'
					}
				}
			},
			gender: {
				validators: {
					notEmpty: {
						message: 'Please select a gender'
					}
				}
			},
		});
	}

	initiateValidation() {
		this.addManualFormValidation(this._element);

		const errorCta = SelectorEngine.findOne('.js-dismiss-error', this._element);
		errorCta.addEventListener('click', (event) => {
			const errorWrapper = event.target.closest('.lta-update-profile--error');
			errorWrapper.classList.add('u-hidden');
			const submitButton = SelectorEngine.findOne('button[type="submit"]', this._element);
			submitButton.disabled = false;
		});

		this.manualFormValidationInstance.on('core.form.valid', async () => {
			const formAction = SelectorEngine.findOne('button[type="submit"]', this._element);
			formAction.disabled = true;

			const dataObject = getDataFromForm(this._element);
			const formSubmission = await Request.post('/api/account/personal', dataObject)
				.catch(() => {
					this.showError('api')
				});

			if (formSubmission) {
				// Redirect back to members home if successful
				window.location.href = `/members/`;
			}
		});
	}
}

export default UpdateProfile;
